import { useState } from "react";
import { useTablesContext } from "../../../../context/tablesContextProvider";
import { TableNames } from "../../../../enums/tableNames";

/**
 * Manages the search term state for the medical PA orders table,
 * initializing from persisted table context if available.
 *
 * @returns The current search term and its setter
 */
export const useSearchTerm = () => {
  const { getTableDataFromContext } = useTablesContext();
  const tableAttributes = getTableDataFromContext(
    TableNames.MEDICAL_PA_ORDERS_NEW,
  );

  const [searchTerm, setSearchTerm] = useState(
    tableAttributes?.searchedText ?? "",
  );

  return { searchTerm, setSearchTerm };
};
